import * as z from "zod";

export const cancelCampaign = {
  name: "cancelCampaign" as const,
  description:
    "Permanently stop an in-progress campaign. Some messages may have already been sent and this can't be undone.",
  mutates: true,
  input: z.object({ id: z.string() }),
  output: z.null(),
};
